<div>
  <div edsGrid>
    <div class="container--wide">
      <ng-container *ngIf="content?.cards?.length; else noCards">
        <div edsRow [ngStyle]="{ 'align-items': 'center', display: 'flex' }">
          <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 4 }">
            <div *ngIf="content.preTitle || content.title || content.summary">
              <ft-intro-section
                [showCta]="true"
                [content]="content"
                [titleColorTheme]="titleColorTheme"
              ></ft-intro-section>
            </div>

            <div
              *ngIf="footnote"
              class="footnote-wrapper"
              edsPadding
              edsPaddingTop="lg"
              [innerHTML]="footnote"
            ></div>
          </div>
          <div
            edsCol
            [offsets]="{ l: 1 }"
            [columnNumbers]="{ s: 4, m: 4, l: 5 }"
          >
            <ng-container *ngTemplateOutlet="cards"></ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noCards>
  <div edsRow>
    <div edsCol>
      <div *ngIf="content?.preTitle || content?.title || content?.summary">
        <ft-intro-section
          [showCta]="true"
          [content]="content"
          [titleColorTheme]="titleColorTheme"
        ></ft-intro-section>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cards>
  <ng-container *ngFor="let card of content.cards | slice: 0:1">
    <eds-media-card
      [title]="card.title"
      [bodyContent]="card.content"
      [isIcon]="card.isIcon"
      [isStacked]="true"
      [hasBorders]="true"
      [hasPadding]="true"
      [hasShadows]="true"
      [imgSrc]="card.imageSrc"
      [linkText]="card.link?.displayText"
      [url]="card.link?.url"
      [isNewWindow]="card.link?.target === '_blank'"
      [externalLink]="card.link?.external"
      [signInRequired]="card.link?.signInLink | ftIsSignInRequired | async"
      [hideLockIcon]="card.link?.hideLockIcon"
      [signInTooltip]="'common.locked-link-tooltip' | translate"
      [downloadLocation]="card.link?.downloadLocation"
      (mediaCardClicked)="setDownloadLocation(card.link?.downloadLocation)"
    >
    </eds-media-card>
  </ng-container>
</ng-template>
